module.exports = __webpack_public_path__ + "static/logo-f5c2b1151a23fd55c8903905f8ef4877.png";